export const ACTION_STATUSES = Object.freeze({
  REMOVED: "removed",
  ACTIVE: "active",
  NEW: "new",
  RE_ENABLE: "re-enable",
});

export const ONBOARDING_KB_ARTICLE_URL =
  "https://help.circle.so/p/audience/onboarding/automatically-grant-free-access-to-spaces-when-members-join-your-community";

export const ACCESS_GROUPS_KB_ARTICLE_URL =
  "https://help.circle.so/p/basics/community-access/access-group-overview";
